const {gql} = require('graphql-tag');
export default gql`
  mutation removeArtworkToFile($id: ID!) {
    removeArtworkToFile(id: $id) {
      id
    }
  }
`;
